<template>
    <el-dialog
        :title="type === 'add' ? '添加' : '修改'"
        :visible.sync="dialogVisible"
        width="900px"
        :before-close="handleClose"
    >
        <el-form
            ref="myForm"
            :model="form"
            label-width="130px"
            label-position="left"
        >
            <el-form-item label="topic:">
                <el-select
                    v-model="form.topic"
                    placeholder="请选择"
                    style="width: 100%"
                >
                    <el-option
                        v-for="item in optionList"
                        :key="item"
                        :label="item"
                        :value="item"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排列序号:">
                <el-input v-model="form.sort"></el-input>
            </el-form-item>
            <el-form-item label="en-title:">
                <el-input v-model="form.en.title"></el-input>
            </el-form-item>
            <el-form-item label="en-description:">
                <el-input type="textarea" v-model="form.en.summary"></el-input>
            </el-form-item>
            <el-form-item label="zh-title:">
                <el-input v-model="form.zh.title"></el-input>
            </el-form-item>
            <el-form-item label="zh-description:">
                <el-input type="textarea" v-model="form.zh.summary"></el-input>
            </el-form-item>
            <el-form-item label="banner">
                <div v-if="imageUrl">
                    <img
                        class="el-upload-list__item-thumbnail"
                        :src="imageUrl"
                        alt=""
                    />
                    <span class="el-upload-list__item-actions">
                        <span @click="handleUploadRemove">
                            <i class="el-icon-delete"></i>
                        </span>
                    </span>
                </div>
                <el-upload
                    action=""
                    list-type="picture-card"
                    :auto-upload="false"
                    :on-change="handleUploadChange"
                    v-else
                >
                    <i slot="default" class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="是否外链">
                <el-switch v-model="form.web_link"></el-switch>
            </el-form-item>
            <el-form-item label="外链地址:" v-if="form.web_link">
                <el-input v-model="form.link_url"></el-input>
            </el-form-item>
            <template v-else>
                <el-form-item label="详情页路由name:">
                    <el-input v-model="form.pathname"></el-input>
                </el-form-item>
                <el-form-item label="en-详情页内容:">
                    <richText ref="enRichRef" />
                </el-form-item>
                <el-form-item label="zh-详情页内容:">
                    <richText ref="zhRichRef" />
                </el-form-item>
                <el-form-item label="预计阅读完时长:">
                    <el-input v-model="form.read_time">
                        <template slot="append">min</template></el-input
                    >
                </el-form-item>
            </template>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">Cancel</el-button>
            <el-button type="primary" :loading="loading" @click="onSubmit"
                >Submit</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import richText from "./rich-text.vue";
import serverApi from "../../../server/index";
import FormData from "form-data";

export default {
    name: "modal",
    props: ["dialogVisible", "type", "initData", "isMain"],
    components: {
        richText,
    },
    data() {
        return {
            imageUrl: "",
            disabled: false,
            file: null,

            optionList: [
                "Product Updates",
                "Market cooperation",
                "Major issues",
                "Related activities",
            ],
            form: {
                en: {
                    title: "",
                    summary: "",
                    detail: "",
                },
                zh: {
                    title: "",
                    summary: "",
                    detail: "",
                },
                sort: 1,
                web_link: false, // 1 true 0 false
                pathname: "",
                read_time: "",
                topic: "",
                banner: "",
                is_main: this.isMain,
            },
            loading: false,
        };
    },
    mounted() {
        if (this.initData && this.type === "edit") {
            console.log("initData--->", this.initData);
            const _data = JSON.parse(JSON.stringify(this.initData));
            this.form = _data;
            this.imageUrl = `https://asset.promptport.ai/files${_data.banner_url}`;
            this.form.web_link = this.initData.web_link == 1;
            setTimeout(() => {
                this.$refs.enRichRef.editor.setHtml(_data.en.detail);
                this.$refs.zhRichRef.editor.setHtml(_data.zh.detail);
            }, 100);
        }
    },
    methods: {
        onSubmit() {
            if (this.form.topic) {
                this.form.topic = this.form.topic.toLowerCase();
            }
            if (this.imageUrl) {
                this.form.banner = this.file ? this.file.raw : this.imageUrl;
            }
            if (!this.form.web_link) {
                this.form.en.detail = this.$refs.enRichRef.editor.getHtml();
                this.form.zh.detail = this.$refs.zhRichRef.editor.getHtml();
            }
            this.form.web_link = this.form.web_link ? 1 : 0;

            console.log("form---->", this.form);

            let _form = new FormData();
            _form.append("banner", this.form.banner);
            _form.append("en", JSON.stringify(this.form.en));
            _form.append("zh", JSON.stringify(this.form.zh));
            _form.append("topic", this.form.topic);
            _form.append("is_main", this.form.is_main);
            _form.append("web_link", this.form.web_link);
            _form.append("sort", this.form.sort);
            if (this.form.web_link) {
                _form.append("link_url", this.form.link_url);
            } else {
                _form.append("read_time", this.form.read_time);
                _form.append("pathname", this.form.pathname);
            }

            this.loading = true;

            if (this.type === "add") {
                serverApi
                    .blogAdd(_form)
                    .then((res) => {
                        console.log("res---->", res);
                        if (res.data.code === 0) {
                            this.$message({
                                message: "Add successfully",
                                type: "success",
                            });
                            this.$emit("closeModal", true);
                        } else {
                            this.$message({
                                message: res.data.msg || res.data.error,
                                type: "error",
                            });
                        }
                    })
                    .catch((e) => {
                        this.$message({
                            message: e.data.error || e.data.msg,
                            type: "error",
                        });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }

            if (this.type === "edit") {
                _form.append("id", this.initData._id);
                serverApi
                    .blogUpdate(_form)
                    .then((res) => {
                        console.log("edit res---->", res);
                        if (res.data.code === 0) {
                            this.$message({
                                message: "Edit successfully",
                                type: "success",
                            });
                            this.$emit("closeModal", true);
                        } else {
                            this.$message({
                                message: res.data.msg || res.data.error,
                                type: "error",
                            });
                        }
                    })
                    .catch((e) => {
                        this.$message({
                            message: e.data.error || e.data.msg,
                            type: "error",
                        });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleUploadChange(file) {
            console.log("file--->", file);
            this.file = file;
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        handleUploadRemove() {
            this.file = null;
            this.imageUrl = "";
        },
        //
        test() {
            console.log(
                "richChange----->",
                this.$refs.enRichRef.editor.getHtml()
            );
        },
        handleClose() {
            this.$emit("closeModal", false);
        },
    },
};
</script>

<style lang="scss">
.el-upload-list__item-thumbnail {
    width: 178px;
    height: 178px;
    display: block;
    border-radius: 6px;
}
.el-upload-list__item-actions {
    display: flex;
    width: 178px;
    height: 178px;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.3s;
    &:hover {
        opacity: 1;
    }

    span {
        cursor: pointer;
    }
}
</style>